import {event} from '../modules/event';
import {ajax} from '../modules/ajax';

/*
* Голосовалка в:
* - фильмах;	 type === 'movies'
* - рецензиях;   type = 'review'
* - трейлкрах;   type = 'video'
*
* если тип "video", то пишем по id трейлера - videoid
 * если тип "video", то пишем по id трейлера - videoid
 * если тип "review" - пишем по id рецензии - reviewid
 *
*
* TODO cделать универсально
*
* */


export default class {
	constructor(wrapper) { 
		this._createElements(wrapper);
		this._addEvents();
	}
	
	_createElements(wrapper){
		this.wrapper = wrapper;
		this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
		this.catId = this.data.catid;
		this.btnAll = this.wrapper.querySelectorAll('[data-VoteResults-btn]');
		this.isSending = false;
		this.ajaxPath = this._defineAjaxPath();
        this.btnBaseModifierClass = APP.vars.isMobile ? 'btn-primary' : 'btn-warning';
	}

	_defineAjaxPath(){
        var self = this,
			part = APP.vars.isDev ? '/_src/layouts/results/vote' : '/itogi/vote';

		return part;
	}

	_addEvents(){

		var self = this;
		for(var i=0, j=this.btnAll.length; i<j; i++){
			event.add(this.btnAll[i], 'click', function(e){

				if (APP.vars.isMobile) {
					if (!APP.auth.tryAuth()) return false;
				} else if (!regAuthObj.isAuth) {
					regAuthObj.authForm.showPopup();
					return false;
				}

				var item_id = this.getAttribute('data-VoteResults-btn');

				self._sendAjax.call(self, e, item_id);
			});
		}
	}

	_sendAjax(e, val){
		e.preventDefault();
		e.stopPropagation();

        let self = this;

		if ( self.isSending ){
			return false;
		}

        self.isSending = true;

		ajax({
			data: {
				"item_id":  val,
				"nomination_id": self.catId,
			},
			method: 'POST',
            url: self.ajaxPath,
			callback: function(result){

                self.isSending = false;

                var resultParse = JSON.parse(result);
                if ( resultParse && resultParse.status ) {

                    for(var i=0, j=self.btnAll.length; i<j; i++){
                    	if ( self.btnAll[i].classList.contains('btn-success') ) {
                            self.btnAll[i].classList.remove('btn-success');
							self.btnAll[i].classList.add(self.btnBaseModifierClass);
						}
                        self.btnAll[i].innerHTML = 'Голосовать';
					}
					e.target.classList.add('btn-success');
					e.target.classList.remove(self.btnBaseModifierClass);
                    e.target.innerHTML = 'Ваш выбор';

				} else{
                	alert('При отправке запроса произошла ошибка!');
				}

			}
		});
	}

    del(){

    }
}







































